import {
	ColorInput,
	ColorPickerWrapper,
	ColorPreview,
	FormContainer,
	FormField,
	Input,
	Label,
	TextArea,
} from './CreateTagModal.styles';
import { CreateTagRequest, TagType } from '../../types';
import { FC, useState } from 'react';
import { PUNCHUP_QUATERNARY, PUNCHUP_TERTIARY } from 'features/common/components/Button/constants';

import { Button } from 'features/common/components/Button';
import { Modal } from 'features/common/components/Modal';
import { useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';

interface CreateTagModalProps {
	onClose: () => void;
	onSubmit: (tag: CreateTagRequest) => void;
	tagType: TagType;
}

const CreateTagModal: FC<CreateTagModalProps> = ({ onClose, onSubmit, tagType }) => {
	const { t } = useTranslation();
	const { isPunchup } = useAppSelector((state) => state.auth);

	const [name, setName] = useState('');
	const [description, setDescription] = useState('');
	const [color, setColor] = useState('#F5F5F5');

	const handleSubmit = () => {
		if (!name.trim()) return;

		onSubmit({
			name: name.trim(),
			description: description.trim() || undefined,
			color,
			tag_type: tagType,
		});

		onClose();
	};

	return (
		<Modal onClose={onClose}>
			<Modal.Header>
				<h2>{t('tags-create-new')}</h2>
			</Modal.Header>
			<Modal.Body>
				<FormContainer>
					<FormField>
						<Label>
							{t('tags-name')} <span style={{ color: 'red' }}>*</span>
						</Label>
						<Input
							type="text"
							placeholder={t('tags-name-placeholder')}
							value={name}
							onChange={(e) => setName(e.target.value)}
							maxLength={50}
						/>
					</FormField>

					<FormField>
						<Label>{t('tags-description')}</Label>
						<TextArea
							placeholder={t('tags-description-placeholder')}
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							maxLength={200}
						/>
					</FormField>

					<FormField>
						<Label>{t('tags-color')}</Label>
						<ColorPickerWrapper>
							<ColorInput type="color" value={color} onChange={(e) => setColor(e.target.value)} />
							<ColorPreview $color={color} />
						</ColorPickerWrapper>
					</FormField>
				</FormContainer>
			</Modal.Body>
			<Modal.ActionButtons>
				<Button text={t('cancel')} category={PUNCHUP_QUATERNARY} onClick={onClose} />
				<Button
					text={t('tags-create-add')}
					category={isPunchup ? PUNCHUP_TERTIARY : undefined}
					onClick={handleSubmit}
					disabled={!name.trim()}
				/>
			</Modal.ActionButtons>
		</Modal>
	);
};

export { CreateTagModal };
